export enum OnAcceptUpSellEnum {
  NAO_FAZER_NADA = 1,
  REDIRECIONAR,
}
